// @flow
import * as types from "../constants/action-types";
import initialState from "./initial-state";
import * as R from "ramda";


export const faqsReducer = R.cond([
    [
        (state, action) => (action.type === types.FETCH_FAQS_SUCCESS),
        (state, action) => {
            return ({
                ...state,
                data: action.payload.data,
                error: null
            });
        }
    ],
    [
        (state, action) => (action.type === types.FETCH_FAQS_FAIL),
        (state, action) => ({
            ...state,
            error: action.payload.error
        })
    ],
    [
        (state, action) => (action.type === types.SAVE_FAQ_SUCCESS),
        (state, action) => ({
            ...state,
            data: { ...state.data, ...action.payload.data },
            error: null
        })
    ],
    [
        (state, action) => (action.type === types.SAVE_FAQ_FAIL),
        (state, action) => ({
            ...state,
            error: action.payload.error
        })
    ],
    [
        (state, action) => (action.type === types.DELETE_FAQ_SUCCESS),
        (state, action) => {
            const data = Reflect.deleteProperty([].concat(state.data), action.payload.data.id || "");
            return ({
                ...state,
                data,
                error: null
            });
        }
    ],
    [
        (state, action) => (action.type === types.DELETE_FAQ_FAIL),
        (state, action) => ({
            ...state,
            error: action.payload.error
        })
    ],
    [
        R.T,
        state => (state || initialState.settings)
    ]
]);
